import DashboardTopBar from './DashboardTopBar';

export default DashboardTopBar;